"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconRepeat1 = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconRepeat1 = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.2929 1.29289C16.6834 0.902369 17.3166 0.902369 17.7071 1.29289L21.7071 5.29289C22.0976 5.68342 22.0976 6.31658 21.7071 6.70711L17.7071 10.7071C17.3166 11.0976 16.6834 11.0976 16.2929 10.7071C15.9024 10.3166 15.9024 9.68342 16.2929 9.29289L18.5858 7H7.8C6.94342 7 6.36113 7.00078 5.91104 7.03755C5.47262 7.07337 5.24842 7.1383 5.09202 7.21799C4.7157 7.40973 4.40973 7.7157 4.21799 8.09202C4.1383 8.24842 4.07337 8.47262 4.03755 8.91104C4.00078 9.36113 4 9.94342 4 10.8V11C4 11.5523 3.55229 12 3 12C2.44772 12 2 11.5523 2 11V10.7587C1.99999 9.95374 1.99998 9.28937 2.04419 8.74817C2.09012 8.18608 2.18868 7.66937 2.43598 7.18404C2.81947 6.43139 3.43139 5.81947 4.18404 5.43598C4.66937 5.18868 5.18608 5.09012 5.74818 5.04419C6.28937 4.99998 6.95373 4.99999 7.7587 5L18.5858 5L16.2929 2.70711C15.9024 2.31658 15.9024 1.68342 16.2929 1.29289Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21 12C20.4477 12 20 12.4477 20 13V13.2C20 14.0566 19.9992 14.6389 19.9624 15.089C19.9266 15.5274 19.8617 15.7516 19.782 15.908C19.5903 16.2843 19.2843 16.5903 18.908 16.782C18.7516 16.8617 18.5274 16.9266 18.089 16.9624C17.6389 16.9992 17.0566 17 16.2 17H5.41421L7.70711 14.7071C8.09763 14.3166 8.09763 13.6834 7.70711 13.2929C7.31658 12.9024 6.68342 12.9024 6.29289 13.2929L2.29289 17.2929C1.90237 17.6834 1.90237 18.3166 2.29289 18.7071L6.29289 22.7071C6.68342 23.0976 7.31658 23.0976 7.70711 22.7071C8.09763 22.3166 8.09763 21.6834 7.70711 21.2929L5.41421 19H16.2413C17.0463 19 17.7106 19 18.2518 18.9558C18.8139 18.9099 19.3306 18.8113 19.816 18.564C20.5686 18.1805 21.1805 17.5686 21.564 16.816C21.8113 16.3306 21.9099 15.8139 21.9558 15.2518C22 14.7106 22 14.0463 22 13.2413V13C22 12.4477 21.5523 12 21 12Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M17 2L21 6M21 6L17 10M21 6H7.8C6.11984 6 5.27976 6 4.63803 6.32698C4.07354 6.6146 3.6146 7.07354 3.32698 7.63803C3 8.27976 3 9.11984 3 10.8V11M3 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V13M3 18L7 22M3 18L7 14",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconRepeat1 = IconRepeat1;
//# sourceMappingURL=IconRepeat1.js.map